module.exports = __webpack_public_path__ + "static/media/bg2.33244bbc.jpg";